<template>
  <app-toast class='delete-realestate-toast' :message='message'>
    <div class='toast-body' v-html='$t("real-estate.delete")'>
    </div>
  </app-toast>
</template>

<script>
  import appToast from '@/components/app-toast'

  export default {
    name: 'delete-realestate',
    props: {
      message: Object
    },

    components: {
      'app-toast': appToast
    }
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .delete-realestate-toast {
    strong {
      color: map_get($palette-primary, main);
    }
  }
</style>
